"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var scrollPosition = {};
var _default = exports["default"] = function _default(Component) {
  return (0, _reactRouterDom.withRouter)(function (props) {
    var url = props.match.url;
    var originalProps = (0, _omit2["default"])(props, ['history', 'location', 'match']);
    var updateScrollPosition = (0, _debounce2["default"])(function () {
      scrollPosition[url] = window.scrollY;
    }, 100);
    (0, _react.useEffect)(function () {
      if (scrollPosition[url] || scrollPosition[url] === 0) {
        window.scrollTo(0, scrollPosition[url]);
      }
      window.addEventListener('scroll', updateScrollPosition);
      return function () {
        window.removeEventListener('scroll', updateScrollPosition);
      };
    }, []);
    return /*#__PURE__*/_react["default"].createElement(Component, originalProps);
  });
};